/* ActionTypes */
import { FETCH_CAROUSEL, CAROUSEL_ENTITY_ACTION_TYPES } from './actionTypes';

/* Utils */
import { generateEntityActionCreators, generateRequestActionCreator } from '../utils/generators/actionGenerators';

export const fetchCarousel = generateRequestActionCreator(({
  sourceCarouselId,
  source,
  sourceProvider,
  filters,
  type,
  max,
  isCheddar,
  recommendationType,
}) => ({
  type: FETCH_CAROUSEL,
  payload: {
    sourceCarouselId,
    source,
    sourceProvider,
    type,
    filters,
    max,
    isCheddar,
    recommendationType,
  },
}));

export const entityActions = generateEntityActionCreators(CAROUSEL_ENTITY_ACTION_TYPES);
